import createRoute   from '@widesk-ui/tools/createRoute';
import TaxonomyModel from '@models/website/TaxonomyModel';

const route = createRoute.dashboardFromModel(
	TaxonomyModel,
	'TaxonomyDashboard',
	{
		pathPrefix: '/configuration',
	},
);
export default route;
